import React, { useCallback, useEffect, useState, lazy } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, CheckCircle2, ChevronLeft, ChevronRight } from 'lucide-react';
const eliteFeatures = [{
  text: 'Cómo responder ante denuncia por mala praxis en paciente menor de edad',
  img: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=1000&h=600&q=80'
}, {
  text: 'Responsabilidad legal cuando los padres se oponen al tratamiento',
  img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1000&h=600&q=80'
}, {
  text: 'Qué hacer cuando el menor revela abuso y el abusador es el progenitor que consiente',
  img: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1000&h=600&q=80'
}, {
  text: 'Protocolo ante conflicto entre padres separados sobre el tratamiento del hijo',
  img: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1000&h=600&q=80'
}, {
  text: 'Plantilla de descargo ante sumario en psiquiatría infantojuvenil',
  img: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1000&h=600&q=80'
}, {
  text: 'Cómo documentar decisiones tomadas contra la voluntad de los padres',
  img: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1000&h=600&q=80'
}, {
  text: 'Comunicación formal con juzgado de familia y OVD',
  img: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?auto=format&fit=crop&w=1000&h=600&q=80'
}, {
  text: 'Organismos de apoyo al médico denunciado en casos con menores',
  img: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1000&h=600&q=80'
}];
export function UpgradeElite() {
  const [index, setIndex] = useState(0);
  const total = eliteFeatures.length;
  const goTo = useCallback((i: number) => {
    setIndex((i % total + total) % total);
  }, [total]);
  const next = useCallback(() => goTo(index + 1), [index, goTo]);
  const prev = useCallback(() => goTo(index - 1), [index, goTo]);
  // Auto-advance (respects reduced motion)
  useEffect(() => {
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    const id = setInterval(() => setIndex(p => (p + 1) % total), 5000);
    return () => clearInterval(id);
  }, [total]);
  const current = eliteFeatures[index];
  return <div className="bg-[#0a1f44] text-white" data-id="element-257">
      <SectionWrapper data-id="element-258">
        <div className="text-center mb-6 md:mb-10" data-id="element-259">
          <p className="text-amber-400 font-bold tracking-wider text-[10px] md:text-xs uppercase mb-2 md:mb-3" data-id="element-260">
            UPGRADE ELITE
          </p>
          <h2 className="text-[22px] md:text-3xl font-extrabold mb-2 md:mb-4 text-balance tracking-tight" data-id="element-261">
            ¿Qué agrega el Blindaje Legal Infantojuvenil Total?
          </h2>
          <p className="text-blue-200 max-w-2xl mx-auto text-[14px] md:text-base text-balance" data-id="element-262">
            Para psiquiatras que no pueden permitirse perder la matrícula
            trabajando con menores
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12 max-w-4xl mx-auto" data-id="element-263">
          <div className="bg-blue-900/30 border border-blue-800/50 rounded-2xl p-5 md:p-6 shadow-sm" data-id="element-264">
            <h3 className="text-red-400 font-bold text-[16px] md:text-lg mb-2 md:mb-3" data-id="element-265">
              Sin Elite
            </h3>
            <p className="text-blue-200/90 text-[13px] md:text-sm leading-relaxed" data-id="element-266">
              Si te denuncian en un caso con menor de edad, no sabés qué hacer
              en las primeras 48 horas. Sin sistema preventivo que construya tu
              escudo legal consulta a consulta.
            </p>
          </div>
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-2xl p-5 md:p-6 shadow-sm ring-1 ring-amber-500/20" data-id="element-267">
            <h3 className="text-amber-400 font-bold text-[16px] md:text-lg mb-2 md:mb-3 flex items-center gap-2" data-id="element-268">
              <Shield className="w-4 h-4 md:w-5 md:h-5" data-id="element-269" /> Con Elite
            </h3>
            <p className="text-blue-50 text-[13px] md:text-sm leading-relaxed" data-id="element-270">
              Sistema completo de protección legal específico para psiquiatría
              infantojuvenil: descargo ante sumario, protocolo ante denuncia
              penal, documentación preventiva diaria y plantillas formales para
              cada situación institucional con menores.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-271">
          <div className="text-center mb-4 md:mb-6" data-id="element-272">
            <h3 className="text-[18px] md:text-xl font-bold text-white mb-1" data-id="element-273">
              EL ELITE INCLUYE
            </h3>
            <p className="text-amber-400 text-[12px] md:text-sm font-bold tracking-wide" data-id="element-274">
              Blindaje Legal Infantojuvenil Total — 50 páginas premium
            </p>
          </div>

          {/* Slider */}
          <div className="relative" data-id="element-275">
            <div className="relative overflow-hidden rounded-3xl border border-blue-800/50 shadow-xl bg-blue-950" data-id="element-276">
              <div className="relative aspect-[16/10] sm:aspect-[16/8] md:aspect-[16/6]" data-id="element-277">
                <AnimatePresence mode="wait" data-id="element-278">
                  <motion.div key={index} initial={{
                  opacity: 0,
                  scale: 1.04
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} exit={{
                  opacity: 0
                }} transition={{
                  duration: 0.5,
                  ease: 'easeOut'
                }} className="absolute inset-0" data-id="element-279">
                    <img src={current.img} alt={current.text} loading="lazy" className="w-full h-full object-cover" data-id="element-280" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a1f44] via-[#0a1f44]/70 to-[#0a1f44]/10" data-id="element-281" />
                    <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-8" data-id="element-282">
                      <div className="inline-flex self-start items-center gap-1.5 bg-amber-400 text-amber-950 text-[10px] md:text-xs font-black px-2.5 py-1 rounded-full mb-3 uppercase tracking-wide" data-id="element-283">
                        <Shield className="w-3 h-3" data-id="element-284" /> Incluido en Elite
                      </div>
                      <div className="flex items-start gap-2.5 md:gap-3 max-w-xl" data-id="element-285">
                        <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-amber-400 shrink-0 mt-0.5" data-id="element-286" />
                        <p className="text-white text-[15px] md:text-xl font-bold leading-snug drop-shadow" data-id="element-287">
                          {current.text}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>

              {/* Arrows */}
              <button onClick={prev} aria-label="Anterior" className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 rounded-full bg-[#0a1f44]/70 hover:bg-orange-600 text-white flex items-center justify-center backdrop-blur-sm transition-colors border border-white/10" data-id="element-288">
                <ChevronLeft className="w-5 h-5" data-id="element-289" />
              </button>
              <button onClick={next} aria-label="Siguiente" className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 rounded-full bg-[#0a1f44]/70 hover:bg-orange-600 text-white flex items-center justify-center backdrop-blur-sm transition-colors border border-white/10" data-id="element-290">
                <ChevronRight className="w-5 h-5" data-id="element-291" />
              </button>
            </div>

            {/* Counter + Dots */}
            <div className="flex items-center justify-center gap-2 mt-4 md:mt-5" data-id="element-292">
              {eliteFeatures.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir a la diapositiva ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-amber-400' : 'w-2 bg-blue-700 hover:bg-blue-500'}`} data-id="element-293" />)}
            </div>
            <p className="text-center text-[11px] text-blue-400/80 mt-2 font-medium uppercase tracking-wider" data-id="element-294">
              {index + 1} / {total} · Deslizá para ver más
            </p>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}